// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c232d3de","556":"aa1fe92d"}[chunkId] + ".chunk.js";
};